import { axiosInstance } from "../axios";

export const bangTinApi = {
  getSummary: () => axiosInstance.get("/news-feed/summary"),
  getImportTotalRecentDays: () =>
    axiosInstance.get("/news-feed/recent-import-total"),
  getExportTotalRecentDays: () =>
    axiosInstance.get("/news-feed/recent-export-total"),
  getPosts: async (params) => {
    try {
      const res = await axiosInstance.get("/news-feed", { params });
      return res?.data ?? { items: [], total: 0 };
    } catch (e) {
      return { items: [], total: 0 };
    }
  },
  getPostDetail: async (id) => {
    const res = await axiosInstance.get(`/news-feed/${id}`);
    return res?.data?.data || res?.data || null;
  },
  createPost: async (data) => {
    const res = await axiosInstance.post("/news-feed", data);
    return res?.data?.data || res?.data || res;
  },
  updatePost: async (id, data) => {
    const res = await axiosInstance.put(`/news-feed/${id}`, data);
    return res?.data?.data || res?.data || res;
  },
  deletePost: async (id) => {
    const res = await axiosInstance.delete(`/news-feed/${id}`);
    return res?.data?.data || res?.data || res;
  },
};
